// @flow
import { ListItem, Paper } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import ContentLoader from "../../../../../components/general/contentLoader/contentLoader";
import CustomTranslation from "../../../../../components/general/customTranslation/customTranslation";
import { exhibitionIsOngoing } from "../../../../../helpers/helpers";
import { useExhibition } from "../../../../../hooks/exhibitions/useExhibition";
import { EXHIBITION, EXHIBITOR_PROFILE } from "../../../../../locales/components/namespaces";
import ScanBarcode from "./partials/scanBarcode";

type Props = {};

const ScanVisitors = (props: Props) => {
	const { exhibitionId: id } = props
	const { exhibition } = useExhibition({ noFetchFiles: true })

	const exhibitionOpen = exhibitionIsOngoing(exhibition)
	const { t } = useTranslation(EXHIBITOR_PROFILE)
	return (
		<div>
			{exhibition ? (
				<React.Fragment>
					<Paper sx={{ mb: 1, p: 1 }} variant={"outlined"}>
						<CustomTranslation
							code={'scan_visitors'}
							translations={exhibition?.translations}
						>
							<Typography component={"div"} variant={"body1"}>
								<Trans
									i18nKey={'exhibitor_scan_visitors'}
									ns={EXHIBITION}
								>
									Here you can scan your visitors.
								</Trans>
							</Typography>
						</CustomTranslation>
					</Paper>
					<Box>
						<Paper sx={{ mb: 1 }} variant={"outlined"}>
							{exhibitionOpen ? (
								<ScanBarcode selectedExhibition={id}/>
							) : (
								<Typography variant={"h6"} sx={{ textAlign: 'center', padding: 2 }}>
									{t('Scan will be available during the exhibition.')}
								</Typography>
							)}
						</Paper>
					</Box>
				</React.Fragment>
			) : (
				<ContentLoader
					loading={!Boolean(exhibition)}
				/>
			)}
		</div>
	);
};

export default ScanVisitors